// @flow
/* eslint sort-keys: "error" */

export const API_BASE_URL = process.env.REACT_APP_SOFARM_API_V1_SERVER || '/api/v1.0';
export const API_V2_URL = process.env.REACT_APP_SOFARM_API_V2_SERVER || '/api/v2.0';
export const API_SP_URL = process.env.REACT_APP_SAFEPAGE_API_SERVER || 'http://safepage.local';
export const BILLING_V1_URL =
  process.env.REACT_APP_BILLING_API_V1_SERVER || 'http://bill.local/api/v1';
export const BILLING_V1_C5_URL =
  process.env.REACT_APP_BILLING_API_V1_SERVER_C5 || 'http://c5.bill.local/api/v1';
export const BILLING_V1_STACKSVAULT_URL =
  process.env.REACT_APP_BILLING_API_V1_SERVER_STACKSVAULT || 'http://stacksvault.bill.local/api/v1';
export const BILLING_V1_ADKONUNIT_URL =
  process.env.REACT_APP_BILLING_API_V1_SERVER_ADKONUNIT || 'http://adkonunit.bill.local/api/v1';
export const BILLING_V1_UNIVERMAG_URL =
  process.env.REACT_APP_BILLING_API_V1_SERVER_UNIVERMAG || 'http://fbblack.bill.local/api/v1';
export const PRELANDINGS_PREVIEW_URL =
  process.env.REACT_APP_SAFEPAGE_PRELANDINGS_SERVER || 'http://safepage.local/prelandings_preview';
export const SOCKET_IO_URL = process.env.REACT_APP_SOCKET_IO_SERVER || 'localhost:3000';
export const AUTH_SERVER_URL = process.env.REACT_APP_OAUTH_SERVER || 'http://auth.sofarm.local';
export const AUTH_V1_URL = `${AUTH_SERVER_URL}/api/v1`;
export const AUTH_DATA = {
  client_id: 'webapp',
  client_secret: 'FgrDeWYtSJNLT3Y6',
};

export default {};



// WEBPACK FOOTER //
// ./src/settings/App.js